// window.SiteReady(($) => {
window.MapsReady(($) => {

  console.log('Init Block: Community Finder');

  function initMarker($marker, data) {
    let lat = $marker.data('lat');
    let lng = $marker.data('lng');
    let id = $marker.data('id');
    let state = $marker.data('state');
    let services = $marker.data('services').toString();

    let latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    };

    let marker = new google.maps.Marker({
      id: id,
      position: latLng,
      map: data.map,
      icon: window.THEME_MAP_MARKER,
      $marker: $marker,
      state: state,
      services: services.split(','),
    });

    data.markers.push(marker);

    let content = $marker.html();

    if (content) {
      let infowindow = new google.maps.InfoWindow({
        content: '<div class="community_finder_infowindow">' + content + '</div>',
      });

      google.maps.event.addListener(marker, 'click', () => {
        if (data.infoWindow) {
          data.infoWindow.close();
        }

        if (data.activeMarker) {
          data.activeMarker.setIcon(window.THEME_MAP_MARKER);
          data.activeMarker.setZIndex(1);
        }

        infowindow.open(data.map, marker);
        data.infoWindow = infowindow;
        data.activeMarker = marker;

        data.activeMarker.setIcon(window.THEME_MAP_MARKER_ACTIVE);
        data.activeMarker.setZIndex(999);
      });
    }
  }

  function updateResults(data) {
    if (data.infoWindow) {
      data.infoWindow.close();
    }

    if (data.activeMarker) {
      data.activeMarker.setIcon( window.THEME_MAP_MARKER );
    }

    data.visible = [];
    data.markers.forEach((marker, index) => {
      // let copy = jQuery.extend(true, {}, marker);

      marker.show = true;

      if (data.selectedPlace) {
        marker.dist = google.maps.geometry.spherical.computeDistanceBetween(data.selectedPlace.geometry.location, marker.position);

        // dist /= 1000; // m to km
        // dist *= 0.6214; // km to miles

        if ( ((marker.dist / 1000) * 0.6214) > 40 ) {
          marker.show = false;
        }
      }

      if (data.selectedState) {
        if (marker.state.indexOf(data.selectedState) < 0) {
          marker.show = false;
        }
      }

      if (data.selectedService) {
        if (marker.services.indexOf(data.selectedService) < 0) {
          marker.show = false;
        }
      }

      if (marker.show) {
        data.visible.push(marker);
      }
    });

    data.visible.sort((a, b) => {
      return a.dist - b.dist;
    });

    data.$container.html('');

    if (data.visible.length == 0) {
      data.$container.append( data.$empty.clone() );
    } else {
      data.visible.forEach((marker) => {
        data.$container.append( marker.$marker.clone() );
      });
    }

    data.$container.scrollTop(0);

    data.$count.html( data.visible.length );

    // window.history.replaceState({}, '', window.location.pathname + '?location=' + data.$input.val());
    window.history.replaceState({}, '', window.location.pathname + '?' + $.param({
      // location: data.$input.val(),
      state: data.$states.val(),
      service: data.$services.val(),
    }));

    centerMap(data);
  }

  function centerMap(data) {
    let bounds = new google.maps.LatLngBounds();
    let markers = data.visible;

    if (data.visible.length == 0) {
      markers = data.markers;
    }

    data.markers.forEach((marker) => {
      marker.setVisible(false);
    });

    markers.forEach((marker) => {
      marker.setVisible(true);

      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng()
      });
    });

    if (data.visible.length == 1) {
      data.map.setCenter(bounds.getCenter());
    } else {
      data.map.fitBounds(bounds);
    }
  }

  //

  function onItemClick(e, data) {
    console.log('Communtiy Finder: Item Click');

    let $target = $(e.currentTarget).parents('.js-map_marker');
    let id = $target.data('id');

    data.markers.forEach((marker) => {
      if (id == marker.id) {
        new google.maps.event.trigger(marker, 'click');
      }
    });
  }

  //

  // function onPlaceSelect(data) {
  //   console.log('Communtiy Finder: Select Place');

  //   let places = data.input.getPlaces();

  //   if (places.length > 0) {
  //     data.selectedPlace = places[0];
  //   } else {
  //     data.selectedPlace = null;
  //   }

  //   updateResults(data);
  // }

  function onServiceSelect(data) {
    console.log('Community Finder: Select Service');

    data.selectedService = data.$services.val();

    updateResults(data);
  }

  function onStateSelect(data) {
    console.log('Community Finder: Select State');

    data.selectedState = data.$states.val();

    updateResults(data);
  }

  function onResetMap(data) {
    console.log('Community Finder: Reset map');

    data.$input.val('');
    data.$states.prop('selectedIndex', 0);
    data.$services.prop('selectedIndex', 0);

    data.selectedPlace = null;
    data.selectedState = null;
    data.selectedService = null;

    updateResults(data);
  }

  //

  function init($el) {
    let data = {
      $el: $el,
      $map: $el.find('.js-community_finder_map'),
      $container: $el.find('.js-map_marker_container'),
      $markers: $el.find('.js-map_marker').detach(),
      $controls: $el.find('.js-community_finder_controls'),
      $input: $el.find('.js-community_finder_input'),
      $states: $el.find('.js-community_finder_states'),
      $services: $el.find('.js-community_finder_services'),
      $reset: $el.find('.js-community_finder_reset'),
      $empty: $el.find('.js-community_finder_empty').detach(),
      $count: $el.find('.js-community_finder_count'),
      markers: [],
      infoWindow: null,
      activeMarker: null,
      selectedPlace: null,
      selectedState: null,
      selectedService: null,
    };

    //

    let mapOptions = {
      zoom: $el.data('zoom') || 12,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      // disableDefaultUI: true,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      styles: window.THEME_MAP_STYLES,
    };

    data.map = new google.maps.Map(data.$map[0], mapOptions);
    // data.input = new google.maps.places.SearchBox(data.$input[0]);

    //

    let params = new URLSearchParams(window.location.search);

    // if (params.get('community')) {
    //   data.$input.val(params.get('community'));

    //   let itemsLoaded = google.maps.event.addDomListener(document.body, 'DOMNodeInserted', (e) => {
    //     console.log('loaded', e.target.className);
    //     if (e.target.className == 'pac-container') {
    //       google.maps.event.removeListener(itemsLoaded);
    //       google.maps.event.trigger(data.input, 'keydown', { keyCode:40 });
    //       google.maps.event.trigger(data.input, 'keydown', { keyCode:13 });
    //       google.maps.event.trigger(data.input, 'focus');
    //       google.maps.event.trigger(data.input, 'keydown', { keyCode:13});
    //     }
    //   });
    // }

    if (params.get('state')) {
      data.$states.val(params.get('state')).change();
      data.selectedState = data.$states.val();
    }

    if (params.get('service')) {
      data.$services.val(params.get('service')).change();
      data.selectedService = data.$services.val();
    }

    //

    data.$markers.each((index, el) => {
      initMarker($(el), data);
    });

    data.visible = data.markers.slice();

    centerMap(data);

    data.$el.on('click', '.js-map_view_item', (e) => {
      onItemClick(e, data);
    });

    data.$controls.on('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });

    // data.$reset.on('click', (e) => {
    data.$el.on('click', '.js-community_finder_reset', (e) => {
      onResetMap(data);
    });

    // data.input.addListener('places_changed', () => {
    //   onPlaceSelect(data);
    // });

    data.$states.on('change', (e) => {
      onStateSelect(data);
    });

    data.$services.on('change', (e) => {
      onServiceSelect(data);
    });

    updateResults(data);

    // window.testinput = data.input;
    return data;
  }

  //

  $('.js-community_finder').each((index, el) => {
    let map = init($(el));
  });

});